import { Injectable } from '@angular/core';
import { Transition, TransitionService } from '@uirouter/angular';

@Injectable({
    providedIn: 'root'
})
export class LocationScopedCacheService {
    public static $name: string = 'clLocationScopedCacheService';

    private areaCacheEntries: any = {};

    constructor(
        private transitionService: TransitionService
    ) {
        this.watchForChangeInApplicationArea();
    }

    // Allows a caller to register a callback that is invoked when the area
    // is navigated away from.
    public addLeavingAreaCallback(areasStateName: string, callback: () => void) {
        this.areaCacheEntries[areasStateName] = callback;
    }

    private watchForChangeInApplicationArea() {
        this.transitionService.onSuccess({}, (trans: Transition) => {
            this.deleteOutOfScopeEntries(trans.$to().name);
        });
    }

    private deleteOutOfScopeEntries(currentAreaStateName: string) {

        for (const cacheKey in this.areaCacheEntries) {
            if (!this.areaCacheEntries.hasOwnProperty(cacheKey)) { continue; }

            if (currentAreaStateName.slice(0, cacheKey.length) !== cacheKey) {

                const callback = this.areaCacheEntries[cacheKey];
                if (typeof callback === 'function') {
                    callback();

                } else {
                    delete this.areaCacheEntries[cacheKey];
                }
            }
        }
    }
}